module.exports = __webpack_public_path__ + "img/index-4.2a09aa66.png";